import { bindCopyButtons } from '../utils';

const initCopyLinkToClipboard = () => {
    bindCopyButtons(document, {
        containerSelector: '.share-link-clipboard:not(.binded)',
        sourceSelector: 'input.input-link',
        buttonSelector: 'button.button-copy-link',
        idleIconSelector: 'button.button-copy-link svg',
        successIconSelector: 'button.button-copy-link i',
        feedbackDuration: 1000,
        boundClass: 'binded'
    });
}

export { initCopyLinkToClipboard }
